import { render, staticRenderFns } from "./borrowing-edit.component.vue?vue&type=template&id=2886a97a&scoped=true"
import script from "./borrowing-edit.component.vue?vue&type=script&lang=ts"
export * from "./borrowing-edit.component.vue?vue&type=script&lang=ts"
import style0 from "./borrowing.style.scss?vue&type=style&index=0&id=2886a97a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886a97a",
  null
  
)

export default component.exports